import TutorialLanguage from '@/components/domains/chat/tutorial/TutorialLanguage.vue';
import TutorialMic from '@/components/domains/chat/tutorial/TutorialMic.vue';
import TutorialQr from '@/components/domains/chat/tutorial/TutorialQr.vue';
import TutorialSingleLanguage01 from '@/components/domains/chat/tutorial/TutorialSingleLanguage01.vue';
import TutorialSingleLanguage02 from '@/components/domains/chat/tutorial/TutorialSingleLanguage02.vue';
import { TutorialState, TutorialType } from '@/types/components';

export const MIN_TUTORIAL_STEP = 1;

export const CHAT_TUTORIAL = [
  {
    key: 'mic',
    title: 'tutorial_microphone_title',
    content: 'tutorial_microphone_content',
    buttonText: 'tutorial_language_button',
    position: 'append',
    component: TutorialMic,
  },
  {
    key: 'language',
    title: 'tutorial_language_title',
    content: 'tutorial_language_content',
    buttonText: 'tutorial_qr_button',
    position: 'append',
    component: TutorialLanguage,
  },
  {
    key: 'qr',
    title: 'tutorial_qr_title',
    content: 'tutorial_qr_content',
    buttonText: 'button_start',
    position: 'prepend',
    component: TutorialQr,
  },
];

export const AUDIENCE_CHAT_TUTORIAL = [
  {
    key: 'mic',
    title: 'tutorial_microphone_title',
    content: 'tutorial_microphone_content',
    buttonText: 'tutorial_language_button',
    position: 'append',
    component: TutorialMic,
  },
  {
    key: 'language',
    title: 'tutorial_language_title',
    content: 'tutorial_language_content',
    buttonText: 'button_start',
    position: 'append',
    component: TutorialLanguage,
  },
];

export const SINGLE_CHAT_TUTORIAL = [
  {
    key: 'mic',
    title: 'tutorial_microphone_title',
    content: 'tutorial_microphone_content',
    buttonText: 'tutorial_language_button',
    position: 'append',
    component: TutorialMic,
  },
  {
    key: 'single-language-home',
    title: 'tutorial_single_language_title',
    content: 'tutorial_language_content',
    buttonText: 'tutorial_single_language_home_button',
    position: 'append',
    component: TutorialSingleLanguage01,
  },
  {
    key: 'single-language-away',
    title: 'tutorial_single_language_title',
    content: 'tutorial_language_content',
    buttonText: 'button_start',
    position: 'append',
    component: TutorialSingleLanguage02,
  },
];

export const initialTutorial = (): Record<TutorialType, TutorialState> => ({
  userGuide: {
    step: MIN_TUTORIAL_STEP,
    maxStep: MIN_TUTORIAL_STEP,
    isCompleted: false,
  },
  chat: {
    step: MIN_TUTORIAL_STEP,
    maxStep: CHAT_TUTORIAL.length,
    isCompleted: false,
  },
  audienceChat: {
    step: MIN_TUTORIAL_STEP,
    maxStep: AUDIENCE_CHAT_TUTORIAL.length,
    isCompleted: false,
  },
  singleChat: {
    step: MIN_TUTORIAL_STEP,
    maxStep: SINGLE_CHAT_TUTORIAL.length,
    isCompleted: false,
  },
});
